export const normalizeInput = (str: string) => {
  return str.toLowerCase().trim();
};
